var map = {
	"./arrow": 13,
	"./arrow.gif": 13,
	"./back-cover": 14,
	"./back-cover.svg": 14,
	"./bg": 15,
	"./bg-mobile": 16,
	"./bg-mobile.png": 16,
	"./bg-warning": 17,
	"./bg-warning.png": 17,
	"./bg.png": 15,
	"./camera": 18,
	"./camera.svg": 18,
	"./charging-issue": 19,
	"./charging-issue.svg": 19,
	"./delivery-box": 20,
	"./delivery-box.png": 20,
	"./delivery-truck": 21,
	"./delivery-truck.png": 21,
	"./dont-know": 22,
	"./dont-know.svg": 22,
	"./ear-speaker": 23,
	"./ear-speaker.svg": 23,
	"./favicon": 24,
	"./favicon.png": 24,
	"./huddersfield": 25,
	"./huddersfield.png": 25,
	"./logo": 26,
	"./logo-light": 27,
	"./logo-light.png": 27,
	"./logo.png": 26,
	"./logo1": 28,
	"./logo1.png": 28,
	"./phone": 29,
	"./phone.svg": 29,
	"./phonerepair": 30,
	"./phonerepair.png": 30,
	"./postal": 31,
	"./postal.png": 31,
	"./repair": 32,
	"./repair.png": 32,
	"./screen-break": 33,
	"./screen-break.svg": 33,
	"./shop": 34,
	"./shop.png": 34,
	"./short-bettery": 35,
	"./short-bettery.svg": 35,
	"./sound-issue": 36,
	"./sound-issue.svg": 36,
	"./thank": 37,
	"./thank.png": 37,
	"./vibration": 38,
	"./vibration.svg": 38,
	"./water-damage": 39,
	"./water-damage.svg": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;